module.exports = __webpack_public_path__ + "img/thumb-collection-fabrica.68d6a4d4.png";